import { useFreestyleTools } from './useFreestyleTools';

export const useHasFreestyleTools = () => {
  const freestyleTools = useFreestyleTools();
  return freestyleTools?.length > 0;
};
